import Vue from 'vue';
import Pusher from 'pusher-js'

// Pusher.logToConsole = true;
const user = JSON.parse(sessionStorage.getItem('user'));
const key = user.pusher_KEY;
const pusher = new Pusher(key, { cluster: 'us2' })

Vue.prototype.$pusher = pusher;

export default pusher;